'use client';

import { createTheme } from '@mui/material/styles';
import breakpoints from '../../styles/breakpoints';

const theme = createTheme({
  typography: {
    fontFamily: 'var(--font-neue-haas-grotesk-text)',
    button: {
      textTransform: 'none',
    },
  },
  palette: {
    primary: {
      main: '#00206A',
      dark: '#03174B',
      light: '#DCE1FF',
    },
    secondary: {
      main: '#595E70',
      light: '#DEE1F9',
      dark: '#0A0E1E',
    },
    error: {
      main: '#BA1A1A',
      light: '#FFDAD6',
      dark: '#410002',
    },
  },
  breakpoints: {
    values: {
      xs: parseInt(breakpoints.xs),
      sm: parseInt(breakpoints.sm),
      md: parseInt(breakpoints.md),
      lg: parseInt(breakpoints.lg),
      xl: parseInt(breakpoints.xl),
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: 'var(--color-white)',
          color: 'black',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        outlined: {
          borderColor: 'var(--color-Outline-Variant-light)',
        },
      },
    },
  },
});

export default theme;
